import * as Types from './types.generated';

import gql from 'graphql-tag';
import { AcademyReadingTimeFragmentDoc } from './articlePage.generated';
import { AssetFieldsFragmentDoc } from './fragments/asset.generated';
import { SeoFieldsFragmentDoc } from './components/componentSeo.generated';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type ChildCategoryCollectionFragment = { __typename: 'PageAcademyCategory', title?: string | null, childArticlesCollection?: { __typename: 'PageAcademyCategoryChildArticlesCollection', items: Array<{ __typename: 'PageAcademyArticle', overviewTitle?: string | null, overviewDescription?: string | null, urlSlug?: string | null, readingTime?: { __typename: 'ComponentArticleReadingTime', min?: number | null, max?: number | null } | null } | null> } | null };

export type ArticleCategoryPageQueryVariables = Types.Exact<{
  slug: Types.Scalars['String'];
}>;


export type ArticleCategoryPageQuery = { __typename: 'Query', category?: { __typename: 'PageAcademyCategoryCollection', items: Array<{ __typename: 'PageAcademyCategory', title?: string | null, description?: string | null, metaTitle?: string | null, metaDescription?: string | null, noFollow?: boolean | null, noIndex?: boolean | null, keywords?: string | null, urlSlug?: string | null, ogImage?: { __typename: 'Asset', title?: string | null, description?: string | null, width?: number | null, height?: number | null, url?: string | null } | null, overviewImage?: { __typename: 'Asset', url?: string | null } | null, linkedSeoTags?: { __typename: 'ComponentSeoTags', title?: string | null, description?: string | null, keywords?: string | null, noFollow?: boolean | null, noIndex?: boolean | null } | null, childCategoriesCollection?: { __typename: 'PageAcademyCategoryChildCategoriesCollection', items: Array<{ __typename: 'PageAcademyCategory', title?: string | null, childArticlesCollection?: { __typename: 'PageAcademyCategoryChildArticlesCollection', items: Array<{ __typename: 'PageAcademyArticle', overviewTitle?: string | null, overviewDescription?: string | null, urlSlug?: string | null, readingTime?: { __typename: 'ComponentArticleReadingTime', min?: number | null, max?: number | null } | null } | null> } | null } | null> } | null } | null> } | null };

export type ArticleCategoriesPageQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type ArticleCategoriesPageQuery = { __typename: 'Query', categories?: { __typename: 'PageAcademyCategoryCollection', items: Array<{ __typename: 'PageAcademyCategory', title?: string | null, description?: string | null, urlSlug?: string | null, childCategoriesCollection?: { __typename: 'PageAcademyCategoryChildCategoriesCollection', items: Array<{ __typename: 'PageAcademyCategory', title?: string | null } | null> } | null } | null> } | null };

export const ChildCategoryCollectionFragmentDoc = gql`
    fragment childCategoryCollection on PageAcademyCategory {
  title
  childArticlesCollection {
    items {
      overviewTitle
      overviewDescription
      urlSlug
      readingTime {
        ...academyReadingTime
      }
    }
  }
}
    ${AcademyReadingTimeFragmentDoc}`;
export const ArticleCategoryPageDocument = gql`
    query articleCategoryPage($slug: String!) {
  category: pageAcademyCategoryCollection(where: {urlSlug: $slug}, limit: 1) {
    items {
      title
      description
      metaTitle
      metaDescription
      ogImage {
        ...assetFields
      }
      noFollow
      noIndex
      keywords
      overviewImage {
        url
      }
      urlSlug
      linkedSeoTags {
        ...seoFields
      }
      childCategoriesCollection(limit: 10) {
        items {
          ...childCategoryCollection
        }
      }
    }
  }
}
    ${AssetFieldsFragmentDoc}
${SeoFieldsFragmentDoc}
${ChildCategoryCollectionFragmentDoc}`;
export const ArticleCategoriesPageDocument = gql`
    query articleCategoriesPage {
  categories: pageAcademyCategoryCollection(
    where: {childCategoriesCollection_exists: true}
    order: overviewOrder_ASC
  ) {
    items {
      title
      description
      urlSlug
      childCategoriesCollection {
        items {
          title
        }
      }
    }
  }
}
    `;